import { betActions } from '../../../store/slices/bets/slice';
import { betsOpenStatuses } from '../../../store/slices/game/selectors';
import { getAcceptedBets } from '../betUtilities/getAcceptedBets';
import { getComputedBets } from '../betUtilities/getComputedBets';
import type { ComputedBet } from '../betUtilities/types';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

declare global {
  interface Window {
    betStateBitMask?: number;
  }
}

export class CoreCommandGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Command;
  public delay = 0;

  public process(_message: GameCommunicationMessageType): void {
    const state = this.store.getState();
    const status = state.gameState.currentStatus;

    if (betsOpenStatuses.includes(status)) {
      this.updateAcceptedBets(getComputedBets(state.bets.betStack));
    }
  }

  private updateAcceptedBets(computedBets: ComputedBet[]): void {
    this.store.dispatch(betActions.setAcceptedBets(getAcceptedBets(computedBets)));
  }
}
